import { CommonModule } from '@angular/common'
import { Component, computed, inject, input, output } from '@angular/core'
import {
  CartDiscountType,
  Experiment,
  getBucket,
  isThermometerKey,
  ProductKey,
} from '@naturalcycles/shared'
import { InfoPopupComponent } from '@src/app/components/modals/info-popup-modal/info-popup.component.js'
import { ModalService } from '@src/app/core/services/modal.service.js'
import { SignalStore } from '@src/app/core/store/signalStore.js'
import {
  getOuraDiscountAsPrice,
  ouraRingDiscount,
  ouraRingDiscountedPriceAB368,
} from '@src/app/core/util/product.util.js'
import { SharedModule } from '@src/app/shared/shared.module.js'
import { EnrichedProduct } from '@src/app/shared/typings/interfaces/products.js'
import { ButtonComponentModule } from '../button/button.component.module.js'

@Component({
  selector: 'app-measuring-device-card',
  templateUrl: './measuring-device-card.component.html',
  styleUrls: ['./measuring-device-card.component.scss'],
  imports: [CommonModule, SharedModule, ButtonComponentModule],
})
export class MeasuringDeviceCardComponent {
  store = inject(SignalStore)

  protected product = input.required<EnrichedProduct>()

  public deviceSelected = output<ProductKey>()

  protected isTest368 = computed(
    () =>
      getBucket(this.store.$experiment().assignments[Experiment.UPDATE_OURA_DISCOUNT]) === 'test',
  )

  protected ProductKey = ProductKey
  protected ouraDiscountAmount = computed(() => {
    const locale = this.store.$userLocale()
    return getOuraDiscountAsPrice(locale.country).toLocaleString(locale.supportedLanguage)
  })

  protected ouraDiscountPercentage = ouraRingDiscount
  protected ouraDiscountedPrice = ouraRingDiscountedPriceAB368
  protected isNcHardware = computed(() => isThermometerKey(this.product().key))

  protected showTag = computed(() => {
    const { key } = this.product()
    const cart = this.store.$cart()
    const discountCode = this.store.$discountCode()

    const isOuraRing = key === ProductKey.OURA_RING_DISCOUNT
    const isNcHardware = this.isNcHardware()
    const hasPredefinedCartApplied = discountCode?.type === CartDiscountType.PredefinedCart
    const thermItem = cart.items.find(item => isThermometerKey(item.key))
    const thermDiscounted = thermItem?.price.discount === 100
    const hideFreeTag = isNcHardware && hasPredefinedCartApplied && !thermDiscounted

    return isOuraRing || (isNcHardware && !hideFreeTag)
  })

  private modalService = inject(ModalService)

  async openInfoModal(): Promise<void> {
    void this.modalService.show({
      component: InfoPopupComponent,
      modalName: 'AppleDeviceCardInfoModal',
      controls: [],
    })
  }

  selected(productKey: ProductKey): void {
    this.deviceSelected.emit(productKey)
  }
}
